import { PassiveSkillDefinition } from '@/data/types'

export const tattooLimits: Record<string, string> = {
  Embrace: '1 Loyalty Tattoo',
  StrNotable: '1 Strength Notable Tattoo',
  DexNotable: '1 Dexterity Notable Tattoo',
  IntNotable: '1 Intelligence Notable Tattoo',
  AttributeNotable: '1 Attribute Notable Tattoo',
  Family: '1 Ancestral Tattoo',
  Keystone: '1 Keystone Tattoo'
}

export const tattooTargetSets: Record<string, string> = {
  SmallStrength: 'Small Strength',
  SmallDexterity: 'Small Dexterity',
  SmallIntelligence: 'Small Intelligence',
  SmallAnyAttribute: 'Small Attribute',
  BigStrength: '+30 to Strength Notable',
  BigDexterity: '+30 to Dexterity Notable',
  BigIntelligence: '+30 to Intelligence Notable',
  Keystone: 'Keystone'
}

export const tattooTribes = [
  'Ngamahu',
  'Kitava',
  'Tukohama',
  'Rongokurai',
  'Tasalio',
  'Arohongui',
  'Ramako',
  'Hinekora',
  'Tawhoa',
  'Valako',
  'Honoured Tattoo'
]

export function skillTattooSets(skill: PassiveSkillDefinition) {
  if (skill.is_keystone) {
    return ['Keystone']
  }
  const keys = Object.keys(skill.stats)
  if (keys.length !== 1) return
  if (keys[0] === 'base_strength') {
    return skill.is_notable
      ? ['BigStrength']
      : ['SmallStrength', 'SmallAnyAttribute']
  } else if (keys[0] === 'base_dexterity') {
    return skill.is_notable
      ? ['BigDexterity']
      : ['SmallStrength', 'SmallDexterity']
  } else if (keys[0] === 'base_intelligence') {
    return skill.is_notable
      ? ['BigIntelligence']
      : ['SmallStrength', 'SmallIntelligence']
  }
}
